// extracted by mini-css-extract-plugin
module.exports = {"hidden":"GcGraph_hidden__IFd9j","font":"GcGraph_font__3KG-V","font1":"GcGraph_font1__Rc3Aq","scroll":"GcGraph_scroll__3jN17"};